import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles(theme => ({
  statusWrapper: {
    background: 'rgb(0, 0, 0, 0.05)',
    borderRadius: theme.spacing(0, 0, 20, 20),
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'center',
    height: theme.spacing(43.5),
  },
  statusText: {
    color: '#233B58',
    paddingLeft: theme.spacing(10),
    font: 'normal normal 600 26px/87px Roboto',
  },
  link: {
    color: '#00B2AE',
    font: 'normal normal 600 26px/87px Roboto',
    textDecoration: 'underline',
    paddingLeft: theme.spacing(5),
    cursor: 'pointer',
  },
}));
